import { ts } from '_core';

import { validate } from './helpers';
import { INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.BACKTEST_DETAILED_VIEW_TRANSACTION_COSTS,
    form: true,
    helpLabel: 'd4c5ugjz0',
    title: 'Transaction Costs',
    neededFiles: ['backtest_tcost_details'],
    interactionParams: Object.values(INTERACTION_PARAMS),
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BACKTEST_DETAILS,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET_DETAILS,
    ],
    clearInteractionOnRegenerate: ['table_dtypes'],

    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
